export interface DegreeProgram {
    /**
     * Specify the name of the university from which you received the degree.
     */
    university?: string
    /**
     * Specify the country in which the university if located.
     */
    country?: string
    /**
     * Specify the city in which the university is located.
     * Only country codes are valid
     */
    city?: string
    /**
     * Select the degree you received.
     * "Bachelor" | "Master" | "Other"
     */
    degree_level?: string
    /**
     * Specify the subject of your degree.
     */
    subject?: string
    /**
     * Specify the best grade points reachable in the grading system.
     */
    max?: number
    /**
     * Specify the grade points that at least need to be reached to pass in the grading system.
     */
    min?: number
    /**
     * Specify the grade points average in your university's grade system.
     */
    gpa?: number

    /*
     * Confirm that you have completed at least 80% of the credit points required for the qualifying degree.
     */
    almost_complete?: boolean

    /*
     * Specify the total number of credit points that the degree program comprises.
     */
    total_credits?: number
}

/**
 * Information about your degree(s).
 */
export interface Degrees {
    /**
     * Qualifying Degree
     */
    qualifying_degree: DegreeProgram
    /**
     * If studied in further degree programs of a university or university of applied sciences that contained courses with competencies that are relevant for you application, you can specify these here.
     */
    further_degree_programs: DegreeProgram[]
}

export function getProgramTitle(program: DegreeProgram): string {
    return program.subject + ", " + program.degree_level + " (" + program.university + ")";
}

export function getDegreeProgramsArray(degrees: Degrees) {
    return [degrees.qualifying_degree, ...degrees.further_degree_programs];
}

export function convertGradePoints(applicantGradePoints: number | undefined, degreeProgram: DegreeProgram | undefined) {
    if (applicantGradePoints && degreeProgram?.country === "DE") {
        return applicantGradePoints;
    } else if (applicantGradePoints && degreeProgram && degreeProgram.min !== undefined && degreeProgram.max !== undefined) {
        const min = degreeProgram.min;
        const max = degreeProgram.max;

        // first we multiply by 100 and round properly
        // to round to the second digit.
        // next cut off the second digit
        // and finally divide by ten again to make it a 1 digit number
        return Math.floor(Math.round((1 + 3 * (max - applicantGradePoints) / (max - min))*100)/10)/10;
    } else {
        return NaN;
    }
}